import { atom, selector } from 'recoil'
import { searchCriteriaState } from './searchCriteria'
import { progressState, recipientsState, scheduledSendingState } from './state'
import { RCS_QUEUING_COMPLETED } from 'Api/beRcs'
import { contentScheduledState } from 'Components/ContentScheduled/recoil/state'

export const pageState = atom({
  key: 'RcsSendingPageState',
  default: {
    loaded: false,
    loading: false,
    error: false,
    severity: 'danger',
    idQueuing: null,
    idScheduledSending: null,
    wizardStep: 1,
    numberOfStepEnabled: 1,
    messageName: '',
    recipients: 'filter',
    totalCredits: null,
    backToStep1Disable: false
  }
})

export const wizardEnableStep1State = selector({
  key: 'RcsSendingEnableStep1State',
  get: ({ get }) => {
    const { includeGroups, excludeGroups, selectedFilters, isNewSerach } = get(
      searchCriteriaState
    )
    const { filetrRecipients, totalRecipients, loadingRecipients } = get(
      recipientsState
    )
    const { recipients } = get(pageState)

    if (loadingRecipients) return false
    if (totalRecipients === 0) return false
    if (filetrRecipients === 0 && recipients !== 'all' && !isNewSerach) {
      return false
    }
    if (
      includeGroups.length > 0 ||
      excludeGroups.length > 0 ||
      selectedFilters.length > 0 ||
      recipients === 'all'
    ) {
      return true
    } else return false
  }
})

export const sendScheduledDisableState = selector({
  key: 'RcsSendingsendsendScheduledDisableState',
  get: ({ get }) => {
    const { isScheduledSending } = get(scheduledSendingState)
    const { validHour, validMinutes, validDate } = get(contentScheduledState)
    const { queueStatus } = get(progressState)

    if (isScheduledSending && (!validHour || !validMinutes || !validDate)) {
      return true
    }

    if (queueStatus !== RCS_QUEUING_COMPLETED) {
      return true
    } else {
      return false
    }
  }
})

export const sendNowDisableState = selector({
  key: 'RcsSendingsendNowDisableState',
  get: ({ get }) => {
    const { isScheduledSending } = get(scheduledSendingState)
    const { validHour, validMinutes, validDate } = get(contentScheduledState)
    const { queueStatus, cost } = get(progressState)

    const { totalCredits } = get(pageState)

    if (isScheduledSending && (!validHour || !validMinutes || !validDate)) {
      return true
    }
    if (cost > totalCredits) {
      return true
    }

    if (queueStatus !== RCS_QUEUING_COMPLETED) {
      return true
    } else {
      return false
    }
  }
})

export const wizardEnableStep2State = selector({
  key: 'RcsSendingEnableStep2State',
  get: ({ get }) => {
    const { numberOfStepEnabled } = get(pageState)
    if (numberOfStepEnabled > 1) return true
    return false
  }
})

export const modalFilterDetailState = atom({
  key: 'RcsSendingModalFilterDetails',
  default: {
    show: false
  }
})
